import {
  normalizeProductSku,
  ProductStatus,
  productToFirestore,
} from '@parallel-fluidics/shared/models/products';
import {
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  query,
  serverTimestamp,
  setDoc,
  where,
} from 'firebase/firestore';

export default async function createProduct({
  sku, name, description, labelQrHeader, labelQrUrl,
}) {
  const db = getFirestore();
  const normalizedSku = normalizeProductSku(sku);

  const existing = await getDocs(query(
    collection(db, 'products'),
    where('sku', '==', normalizedSku),
    limit(1),
  ));
  if (!existing.empty) {
    throw new Error(`SKU already exists: ${normalizedSku}`);
  }

  const productRef = doc(collection(db, 'products'));
  await setDoc(productRef, productToFirestore({
    sku: normalizedSku,
    name: name?.trim(),
    description: description?.trim() || null,
    status: ProductStatus.DRAFT,
    activeVersionId: null,
    labelQrHeader: labelQrHeader?.trim() || null,
    labelQrUrl: labelQrUrl?.trim() || null,
  }, serverTimestamp));

  return productRef.id;
}
